export default __webpack_public_path__ + "static/media/user_uni.84a5bc41.svg";